"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = void 0;
const _imports_1 = require("./_imports");
// Zod schemas for DeliverableArtifactProperty.Config
const BaseConfigSchema = _imports_1.z.object({
    type: _imports_1.z.enum(_imports_1.Deliverable.DeliverableTypes),
    configKey: _imports_1.z.string(),
    relativeRecurringDateConfig: _imports_1.RecurringDate.RelativeConfigSchema,
});
const SupplementalTapeConfigSchema = BaseConfigSchema.extend({
    type: _imports_1.z.literal('supplementalTape'),
    artifactSlug: _imports_1.z.string(),
});
const MonthlyServicerReportConfigSchema = BaseConfigSchema.extend({
    type: _imports_1.z.literal('monthlyServicerReportXlsx'),
    reportName: _imports_1.z.string(),
});
const CashBalancesFeedConfigSchema = BaseConfigSchema.extend({
    type: _imports_1.z.literal('cashBalancesFeed'),
});
const RepaymentTapeConfigSchema = BaseConfigSchema.extend({
    type: _imports_1.z.literal('repaymentTape'),
    loanProductSlug: _imports_1.z.string(),
});
const LoanTapeConfigSchema = BaseConfigSchema.extend({
    type: _imports_1.z.literal('loanTape'),
    loanProductSlug: _imports_1.z.string(),
});
const PortfolioCovenantConfigSchema = BaseConfigSchema.extend({
    type: _imports_1.z.literal('portfolioCovenant'),
    covenantKey: _imports_1.z.string(),
});
const FinancialCovenantConfigSchema = BaseConfigSchema.extend({
    type: _imports_1.z.literal('financialCovenant'),
    covenantKey: _imports_1.z.string(),
});
const OrgProvidedInputConfigSchema = BaseConfigSchema.extend({
    type: _imports_1.z.literal('orgProvidedInput'),
    key: _imports_1.z.string(),
    artifactSlug: _imports_1.z.string().optional(),
});
const MonthlyStatementConfigSchema = BaseConfigSchema.extend({
    type: _imports_1.z.literal('monthlyStatement'),
    reportingPeriodStartDateFormula: _imports_1.z.string(),
    reportingPeriodEndDateFormula: _imports_1.z.string(),
});
const FinancialStatementConfigSchema = BaseConfigSchema.extend({
    type: _imports_1.z.literal('financialStatement'),
    artifactSlug: _imports_1.z.string(),
    financialDataArtifactSlug: _imports_1.z.string(),
});
exports.ConfigSchema = _imports_1.z.discriminatedUnion('type', [
    SupplementalTapeConfigSchema,
    MonthlyServicerReportConfigSchema,
    CashBalancesFeedConfigSchema,
    RepaymentTapeConfigSchema,
    LoanTapeConfigSchema,
    PortfolioCovenantConfigSchema,
    FinancialCovenantConfigSchema,
    OrgProvidedInputConfigSchema,
    MonthlyStatementConfigSchema,
    FinancialStatementConfigSchema,
]);
//# sourceMappingURL=DeliverableArtifactProperty.js.map